import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useState } from 'react';
import DailyPill from '../Containers/DailyPills'
import { LAUNCH } from '../Components/CBtn'
// import * as loader from '../Assets/Preloaders/238.gif'
// import NavBar from '../Components/NavBar';
// import history from '../history'
import AlertMsg from '../Components/AlertMsg';
import NavigBtn from '../Components/NavigBtn';
import PushCards from '../Components/PushCards';
import Footer from '../Components/Footer';
 
// import FinReport from '../Components/FinReport';

const ERROR = styled.section`
img {

    display: flex;
    height: 50vh;
    width: 35vw;
    margin-left: 30%;
    margin-right: 30%;
    margin-top: 10vh;

    @media screen and (max-width: 48rem) {
        width: 70vw;
        margin-left: 15%;
        margin-right: 15%;


    }
}
h2 {
    color: #48596a;
    text-align: center;
    margin-top: 3rem;
    font-size: large;
}
`

const INPUT = styled.input`
@media screen and (min-width: 47.5rem) {
    font-size: larger;
}
display: block;
margin-top: 1rem;
padding: 1.2rem;
width: 70%;
border-top-color: transparent;
border-right-color: transparent;
border-left-color: transparent;
border-bottom: .5px solid #a4508b;
outline: none;
transition: ease-in-out 1s;

&:focus {
    border-bottom: 1.2px solid linear-gradient(326deg, #a4508b 0%, #5f0a87 74%);
    transition: ease-in-out 2s;
 
}
`
const SELECT = styled.select`
@media screen and (min-width: 48rem) {
    font-size: large
}
outline: none;
padding: 1rem;
width: 70%;
border: 1.2px #a4508b;
border-style: dashed;
 `

const ADD = styled( LAUNCH  )`
padding-left: 1rem;
padding-right: 1rem;
margin-right: 1.5rem;
border: none;
outline: none;
border-radius: 2rem;
float: right;
margin-top: 1rem;
transition: 1.5s ease-in-out;

 
&:hover {
    transform: translateY(-.3rem);
    transition: .5s ease-in-out;
    box-shadow: .3rem .3rem .3rem silver;
    background: transparent;
    color: black;
    border: 2px solid #a4508b;
    font-weight: normal;
}

 &.disabled {
     opacity: .7;

     transform: translateX(-.3rem);

    transition: 1.5s ease-in-out;

}
 
`

const LSCREEN = styled.section`
@media screen and (min-width: 48rem) {
display: flex;
flex-flow: column;
align-items: center;
 border: silver;
 margin: 20vh auto auto auto;
max-width: 75%;
}
@media screen and (max-width: 48rem) {
margin-top: 3rem;
}
`
 
const LOADER = styled.section`
@media screen and (max-width: 48rem) {
    display: flex;
    flex-flow: column;
    width: 100vw;
    justify-content: center;
    height: 100vh;
    align-items: center;
}

@media screen and (min-width: 48rem) {
    display: flex;
    flex-flow: column;
    width: 100vw;
    justify-content: center;
    height: 100vh;
    align-items: center;
}
`
const CARDS = styled.section`
@media screen and (max-width: 48rem) {
   width: 100%;
   overflow: auto; 

}
@media screen and (min-width: 48rem) {
   width: 95%;
   overflow: auto; 
}
`
const Dashboard = ({budg, moneySpent, moneyReciv, getDataFromMongo, loading, sendNewDataToMongo, allFs, moneyRecivSpec}) => {
    const[budgList, setBudg] = useState([]);
    const[spentAmt, setSA] = useState('');
    const[spentOpt, setSO] = useState('');
    const[recAmt, setRA] = useState('');
    const[recPur, setRP] = useState('');
    const[spePur, setSP] = useState('');
    const[transType, setTT] = useState('');
    const[btnT, setBT] = useState('Save');
    const[btnSt, setBSt] = useState(false);
    const[btnTR, setBTR] = useState('Save');
    const[btnStR, setBStR] = useState(false);
    const[show, setShow] = useState(false);
     const[specMonRec, setSpecMR] = useState('');
    const[specMonOp, setSpecOpt] = useState('');
    const[specMonPur, setSpecPur] = useState('');
    const[btnSpecSt, setSpecBtnSt] = useState(false);
    const[btnSpecR, setSpecBtnR] = useState('Save');
    const[startGet, setStartGet] = useState(false);
    const[loadErr, setLoadErr] = useState(false);

  
     useEffect(() => {
        document.title = `Iamwealthy@${sessionStorage.getItem('mail')}`

         alert(`Hi, our dashboard is still under-going design \n
         pls we will update it by 09/10/2020 with more features`)

     }, [])
    const handleSpentPur = ({target}) => {
        setSP(target.value)
    }
    const handleSpecOpt = ({target}) => setSpecOpt(target.value)
   
   const handleSpecPur = ({target}) => setSpecPur(target.value)
    const handleSpecMonAmt = ({target}) => setSpecMR(target.value)
    const handleSpentAmt = ({target}) => {
            setSA( Number(target.value))
    }

    const handleSpentOptions = ({target}) => {
            setSO(target.value.toString().trim())
    }
    const handleRecAmt = ({target}) => {
        setRA( Number(target.value) )
     }
    const handleRecPurp = ({target}) => {
        setRP(target.value.toString())
    }
    const handleSpentDispatch = async () => {
        if( spentAmt !== '' && spentOpt !== '' && spePur !== '' ) {
            if(window.confirm(`You are about to save a transaction of \n \n ~ ${spentAmt} \n \n  for the purpose of \n \n ~ ${spePur}`)) {

             let {type} = await moneySpent({budg: spentOpt, amt: spentAmt, purpose: spePur})
             setBSt(true)
             setBT('Saving...')
            
             try {
                if(type === 'SPENT_BUDG') {
                    // console.log(allFs.filter(s => s.updated !== false))
                    let {status} = await sendNewDataToMongo(allFs.filter(s => s.updated !== false))
                    if(status === 'successfull') {
                   alert('transaction recorded!!! spend less and save more, thanks.')
                   setSA('')
                   setSP('')
                   setBT('Save')
                   setBSt(false)
                   setShow(true)

   
               } 
               else throw Error
                }
                
                } 
            catch (error) {
                alert('Unable to save, pls try again') 
                setBT('Save')
                setBSt(false) 
              
                }
                
            }
            else {
                return ''
            }
            
             
            }
      else return ''
    }
    const handleRecivDispatch = async () => {
        if( recPur !== '' && recAmt !== '') {
            if(window.confirm(`You are about to save a transaction of \n \n ~ ${recAmt} \n \n  for the purpose of \n \n ~ ${recPur}`)) {
            let {type} = await moneyReciv({purpose: recPur.trim(), amt: recAmt})
                setBStR(true)
                setBTR('Saving...')
                try {
                    if(type === 'RECIV_BUDG') {
                        
                        if(allFs.length > 0) {
                            console.log('status', allFs)
                             let {status} = await sendNewDataToMongo(allFs)
                        if(status === 'successfull') {
                            alert('transaction recorded!!! save more and get wealthier, thanks.')
                            setRP('')
                            setRA('')
                            setBTR('Save')
                            setBStR(false)
                            setShow(true)
                                                        
        } 
        else throw Error
            
            
                        }
                    }
                }
                 catch (error) {
                     setBTR('Save')
                    setBStR(false) 
                    alert('Unable to save, pls try again') 
    
                  }
            }
            else {
                return ''
            }
           
        } 
        else return ''
    }
    const handleSpecRecDispatch = async () => {
        if(specMonPur !== '' && specMonRec !== '') {
            if(window.confirm(`You are about to save a transaction of \n \n ~ ${specMonRec} \n \n  for the purpose of \n \n ~ ${specMonPur}`)) {
            let {type} = await moneyRecivSpec({purpose: specMonPur.trim(), budg: specMonOp, amt: specMonRec  })
            setSpecBtnSt(true)
            setSpecBtnR('Saving...')

            try {
                if(type === 'SPEC_RECIV_BUDG') {
                    let {status} = await sendNewDataToMongo(allFs.filter(s => s.updated !== false))
                    if(status === 'successfull') {
                alert('transaction recorded!!! save more and get wealthier, thanks.') 
                setSpecMR('')
                setSpecPur('')
                setSpecBtnR('Save')
                setShow(true)

                    } 
                    else throw Error
               }
            }
            catch(e) {
                alert('Unable to save, pls try again')
                setSpecBtnR('Save')
                setSpecBtnSt(false)

            }
            }
        }
    }
   
const handleTransSelect = ({target}) => {
setTT(target.value)
}

const getSt = st => {
    if(st === true) setShow(false)
}
useEffect(() => {
 if(allFs.length < 1) {

     getDataFromMongo()
 }
     setStartGet('am set')
 
},[getDataFromMongo, allFs])

useEffect(() => {
if(startGet === 'am set') {
    
 
    const {isLoading} = loading[0] 
 
    if(!isLoading) {
        //handle the server Error here, and update the UI with setLoadErr useState
        setLoadErr(true)
    }

    if(isLoading === 'no load') {
      window.location.replace('/finance')
    }
    if(isLoading === 'not logged in') {
      window.location.replace('/Iamwealthy/login')
    }

}
},[startGet, loading])
    useEffect(() => {
         setBudg(budg)
 
   
         
        },[budg, budgList])
             if(allFs !== '') return ( 
                   <>
             {/* <NavBar />   */}
              {show ? <AlertMsg getSt={getSt} msg = {'You may have to refresh to view changes'} action = 'REFRESH'/> : '' }
                   {/* <FinReport reportSheet={() => ''} monSpendTot ={2020} monGainTot ={2020} balc={4040} /> */}
               <PushCards />
             
             
             <NavigBtn /> 
             
             
             {/* //section for money recieve today */}
             <LSCREEN>
             <span id='top'></span>
             
             <section>
                   <h3 >
                       Money Recieved Today ?
                   </h3>
                   <form style={{marginLeft:'.5rem'}}>
                       <label htmlFor='amount'> Amount </label>
                       <INPUT 
                       type='number' 
                       placeholder='just the amount e.g 200'
                       value={recAmt}
                       id='amount'
                       onChange={handleRecAmt}
                        />
             
                       <label htmlFor='from' style={{marginTop:'2rem', display:'block'}}> From </label>
                       <INPUT 
                       as='textarea' 
                       type='text' 
                       style={{lineHeight: '1.5rem'}}
                       placeholder='how you earned the money'
                       value={recPur}
                       required={true}
             
                       onChange={handleRecPurp}
                        />
                   </form>
                   
                   <ADD onClick={handleRecivDispatch} disabled={btnStR} style={{cursor:'pointer'}} className={btnStR ?'disabled' : ''} >{btnTR}</ADD>
               </section>
             
             {/* section for money spent */}
             
               <section style={{marginTop:'7rem'}}>
                   <h3 >
                       Money Spent / Withdrawn Today ?
                   </h3>
                   <form style={{marginLeft:'.5rem'}}>
                       <label htmlFor='amount'> Amount </label>
                       <INPUT 
                       type='number' 
                       id='amount' 
                       placeholder='just the amount e.g 200'
                       value={spentAmt}
                       onChange={handleSpentAmt}
                       required={true} />
                       <br />
                       <br />
                       <label 
                       htmlFor='on' 
                       style={{marginTop:'2rem', display:'block'}}>
                            On what 
                       </label>
                       
                           <SELECT  
                           id='on' 
                           required={true}
                            onChange={handleSpentOptions}>
                           <option value={'choose from list'}>{'choose from list'}</option>
                           {
                               budgList.map((list, i) => {
                                if(typeof(list) === 'object') {
                                   return <option value={'choose from list'}>{'choose from list'}</option>
                               }
                             else return <option key={i} value={`${list}`}>{`${list}`}</option>} )
                           }
                           
                           </SELECT>
                           <br />
                           <br />
                           <br />
                           <label htmlFor='amount'> Purpose </label>
                          
                       <INPUT 
                       type='text'
                       as='textarea' 
                       id='amount'
                       required={true} 
                       placeholder='what you spent the money on'
                       value={spePur}
                       onChange={handleSpentPur}
                       style={{lineHeight: '1.5rem'}}
                        />
                          
                    </form>
             
                    <ADD onClick={handleSpentDispatch} disabled={btnSt}  style={{cursor:'pointer'}} className={btnSt ?'disabled' : ''} >{btnT}</ADD>
               </section>
             
               {/* section for money reciv on spec purp */}
             
               <section style={{marginTop:'7rem'}}>
               <h3 >
                       SPECIFIC Money Recieved ?
                   </h3>
                   <form style={{marginLeft:'.5rem'}}>
                       <label htmlFor='amount'> Amount </label>
                       <INPUT 
                       type='number' 
                       id='amount' 
                       placeholder='just the amount e.g 200'
                       value={specMonRec}
                       onChange={handleSpecMonAmt}
                       required={true} />
                       <br />
                       <br />
                       <label 
                       htmlFor='on' 
                       style={{marginTop:'2rem', display:'block'}}>
                            On what 
                       </label>
                       
                           <SELECT  
                           id='on' 
                           required={true}
                            onChange={handleSpecOpt}>
                           <option value={'choose from list'}>{'choose from list'}</option>
                           {
                               budgList.map((list, i) => {
                                if(typeof(list) === 'object') {
                                   return <option value={'choose from list'}>{'choose from list'}</option>
                               }
                             else return <option key={i} value={`${list}`}>{`${list}`}</option>} )
                           }
                           
                           </SELECT>
                           <br />
                           <br />
                           <br />
                           <label htmlFor='amount'> Purpose </label>
                          
                       <INPUT 
                       type='text'
                       as='textarea' 
                       id='amount'
                       required={true} 
                       placeholder='how you earned the money'
                       value={specMonPur}
                       onChange={handleSpecPur}
                       style={{lineHeight: '1.5rem'}}
                        />
                          
                    </form>
                    <ADD onClick={handleSpecRecDispatch} disabled={btnSpecSt} style={{cursor:'pointer'}} className={btnSpecSt ? 'disabled' : ''} >{btnSpecR}</ADD>
               </section>
               <hr style={{marginTop:'7rem'}} id='trans' />
               <br />
                
                           <CARDS 
                           
                           style={{borderTopLeftRadius:'3rem', borderTopRightRadius:'3rem', paddingTop:'3rem', background: 'navajowhite', height:'35rem', margin:'0 auto 0 auto'}}>
             
                           <h3 style={{textAlign:'center'}}>
                               <SELECT onChange={handleTransSelect}>
                                   <option>choose from list</option> 
                                   <option style={{marginTop:'1rem'}}>Money left / Latest transactions</option>
                                   <option>Daily transactions</option>
                                   <option>Weekly transactions</option>
                                   <option>Monthly transactions</option>
                                   <option>AI suggestions / summary</option>
                               </SELECT>
                           </h3>
                            <DailyPill transType={transType} />
                            <span id='down'></span>
                            </CARDS>
             
             
             <Footer />
             </LSCREEN>
             </>
             );
    if(loading) {
        return(
            <>
            {/* <section style={{width:'100%'}}>
              

         {/* <NavBar />   */}
          {/* {loadErr ? <AlertMsg msg={`An Error occured, pls check your network and refresh \n 
          Or try log in`} action='FIN_NET_ERR' getSt={() => loadErr}  /> : '' }
         </section> */}  


<LOADER style={loadErr ? {display:'none'} : {display:'flex'} }>
<img src={require('../Assets/Preloaders/25.gif')} alt='preloader' /> 
<br />
<br />
<div>loading your data</div>
</LOADER>

{
    <ERROR  style={!loadErr ? {display:'none'} : {display:'block'} }>
    <img 
    src={require('../Assets/Images/err.png')} alt={'error occured'}
    style={!loadErr ? {display:'none'} : {display:'block'} } />
    <h2> Error loading page, try refreshing...</h2>

    </ERROR>
}
          

            </>
            )
        }
}
 
  
export default Dashboard;